import  MainLayout from './layout/MainLayout.svelte';

import Timeline from '../components/Timeline.svelte';
import Form from '../components/Form.svelte';
import View from '../components/View.svelte';

import {URL_APPEND} from '@general/constants';

function userLoggedIn() {
	let sessUser = sessionStorage.getItem('uemail')
    return !!sessUser
}

let routes = [
	{
		name: '/',
		layout: MainLayout,
		component: Timeline,
	},
	{
		name: 'form',
		onlyIf: { guard: userLoggedIn, redirect: URL_APPEND + '/timeline' },
		layout: MainLayout,
		component: Form,
		nestedRoutes: [
            { name: 'edit/:uuid', component: Form }
        ]
	},
	{
		name: 'timeline',
		layout: MainLayout,
		component: Timeline,
	},
	{
		name: 'view',
		onlyIf: { guard: userLoggedIn, redirect: URL_APPEND + '/timeline' },
		layout: MainLayout,
		component: View,
	},
]

// routes = [{ name: URL_APPEND, nestedRoutes: routes }]

export {routes};